// Neurological subsection form field enum
export enum NeurologicalFormField {
  NEURO_HEADACHES = 'medicalBackground/neuro/headaches',
  NEURO_HEADACHE_TYPE = 'medicalBackground/neuro/headacheType',
  NEURO_SEIZURES = 'medicalBackground/neuro/seizures',
  NEURO_SEIZURE_DATE = 'medicalBackground/neuro/seizureDate',
  NEURO_SEIZURE_TYPE = 'medicalBackground/neuro/seizureType',
  NEURO_SEIZURE_PRECAUTIONS = 'medicalBackground/neuro/seizurePrecautions',
  NEURO_STATUS = 'medicalBackground/neuro/neuroStatus',
  NEURO_ALTERED_AFFECT = 'medicalBackground/neuro/alteredAffect',
  NEURO_ALTERED_AFFECT_FACTORS = 'medicalBackground/neuro/alteredAffectFactors',
  NEURO_PHQ2_SCREENING = 'medicalBackground/neuro/phq2Screening',
  NEURO_PHQ2_NOTES = 'medicalBackground/neuro/phq2Notes',
  NEURO_INTEREST = 'medicalBackground/neuro/interest',
  NEURO_DEPRESSED = 'medicalBackground/neuro/depressed',
  NEURO_CAREGIVER_DIFFICULTY = 'medicalBackground/neuro/caregiverDifficulty',
  NEURO_SYSTEM_SUMMARY = 'medicalBackground/neuro/systemSummary'
}
